module.exports = __webpack_public_path__ + "media/images/blue-button-right-0e1a2d9092548ea142f45cbb011693d3.png";